import React, { useState, useEffect, useRef } from "react";
import Select from "react-dropdown-select";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";

import app from "../../../firebase/database";
import api from "../../../services/api";

import close from "../../../images/svg/close.svg";

const ModalPowerBi = ({
    business,
    selectBusiness,
    setSelectBussines,
    setShowModal,
    showModal,
    data,
    setSelectPowerBI,
    setUpdateDashboards,
}) => {
    const hiddenFileInput = useRef(null);

    const [image, setImage] = useState("");
    const [title, setTitle] = useState("");
    const [link, setLink] = useState("");
    const [accessUser, setAccessUser] = useState([]);
    const [allAccess, setAllAccess] = useState(false);

    const [imageError, setImageError] = useState(false);
    const [titleError, setTitleError] = useState(false);
    const [linkError, setLinkError] = useState(false);
    const [accessUserError, setAccessUserError] = useState(false);
    const [selectBusinessError, setSelectBussinesError] = useState(false);

    const [options, setOptions] = useState([]);
    const [createOption, setCreateOption] = useState([])

    const buttonStyle = {
        backgroundColor: "#000",
        width: "95px",
        height: "40px",
        borderRadius: "50px",
        border: "none",
        color: "#fff",
    };

    const styleImage = {
        width: "100%",
        height: "150px",
        borderRadius: "10px",
        background: "white",
        border: "1px solid #D7D7D7",
        objectFit: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    };

    const styleImageError = {
        width: "100%",
        height: "150px",
        borderRadius: "10px",
        background: "white",
        border: `2px solid #EA0000`,
        objectFit: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    };

    const inputStyle = {
        display: "flex",
        height: "50px",
        alignItems: "center",
        borderRadius: "12px",
        border: `2px solid #D7D7D7`,
        background: "#F9F9F9",
        width: "100%",
        paddingLeft: "10px",
        paddingRight: "10px",
        marginRight: "15px",
        backgroundColor: "#fff",
    };

    const inputStyleError = {
        display: "flex",
        height: "50px",
        alignItems: "center",
        borderRadius: "12px",
        border: `2px solid #EA0000`,
        background: "#F9F9F9",
        width: "100%",
        paddingLeft: "10px",
        paddingRight: "10px",
        marginRight: "15px",
        backgroundColor: "#fff",
    };

    const styleSelect = {
        display: "flex",
        alignItems: "center",
        borderRadius: "12px",
        minHeight: "50px",
        border: `2px solid #d7d7d7`,
        background: "#F9F9F9",
        width: "100%",
        paddingLeft: "10px",
        paddingRight: "10px",
        marginRight: "15px",
        backgroundColor: "#fff",
    };

    const styleSelectError = {
        display: "flex",
        height: "50px",
        alignItems: "center",
        borderRadius: "12px",
        border: `2px solid #EA0000`,
        background: "#F9F9F9",
        width: "100%",
        paddingLeft: "10px",
        paddingRight: "10px",
        marginRight: "15px",
        backgroundColor: "#fff",
    };


    const handleEditOrAdd = async () => {
        if (!image || !title || !link || !accessUser || (!selectBusiness[0]?.business && !data)) {
            if (!image) {
                setImageError(true);
            }

            if (!title) {
                setTitleError(true);
            }

            if (!link) {
                setLinkError(true);
            }

            if (!accessUser || accessUser.length <= 0) {
                setAccessUserError(true);
            }

            if (!selectBusiness[0]?.business && !data) {
                setSelectBussinesError(true);
            }

            return false;
        }

        try {
            const requestData = {
                image,
                title,
                link,
                accessUser,
                business: data.business ? data.business : selectBusiness[0].business,
                general_access: allAccess,
            };

            if (data.id) {
                const response = await api.patch("/dashboard/edit", {
                    requestData,
                    id: data.id,
                });
                if (response.status === 200) {
                    setUpdateDashboards((prevState) => !prevState);
                }
                toast.success("Atualizado com sucesso!", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setSelectPowerBI({});
                setShowModal(false);
                return false;
            }

            await api.post("/dashboard/create", { requestData });
            setUpdateDashboards((prevState) => !prevState);
            toast.success("Adicionado com sucesso!", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            setSelectPowerBI({});
            setShowModal(false);
            setSelectBussines([]);
        } catch (error) {
            console.log("Erro no envio de dados!")
        }
    };

    const handleClick = (event) => {
        hiddenFileInput.current.click();
    };

    const loadImage = async (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        await app
            .storage()
            .ref(`/profile/${file.name}`)
            .put(file)
            .then(() => {
                app
                    .storage()
                    .ref(`/profile/${file.name}`)
                    .getDownloadURL()
                    .then(async (url) => {
                        setImage(url);
                    });
            });
    };

    useEffect(() => {
        getAllClientsAccess();
        setImage(data.image);
        setTitle(data.title);
        setLink(data.link);
        setAllAccess(data.general_access);
        if (!data.id) {
            setAccessUser([])
        }
    }, [data]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const currentClient = await api.get("/client/profile/one");
        const businessClient = currentClient.data.business;
        const allClients = await api.get("/client/BI");
        setOptions(allClients.data.filter((e) => e.business === businessClient));
    };

    useEffect(() => {
        getAllClientsAccess();
    }, [selectBusiness])

    const getAllClientsAccess = async () => {
        try {
            if (data?.id) {
                const allClientsByBusiness = await api.post("/client/getAllByBusiness", { business: data.business });
                setOptions(allClientsByBusiness.data)

                const response = await api.post("/dashboard/getAllClientsByDashboardId", { id: data.id });
                setAccessUser(response.data);
            }

            if (selectBusiness[0]?.business) {
                const allClientsByBusiness = await api.post("/client/getAllByBusiness", { business: selectBusiness[0]?.business });
                setCreateOption(allClientsByBusiness.data)
            }
        } catch (error) {
            console.log("Erro na busca por dados!")
        }
    };

    useEffect(() => {
        setImageError(false);
    }, [image]);

    useEffect(() => {
        setTitleError(false);
    }, [title]);

    useEffect(() => {
        setLinkError(false);
    }, [link]);

    useEffect(() => {
        setAccessUserError(false);
    }, [accessUser]);

    useEffect(() => {
        setSelectBussinesError(false);
        setAccessUser([])
    }, [selectBusiness]);


    return (
        <>
            <ToastContainer />
            <Modal
                dialogClassName="modal-filter-edit"
                show={showModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                scrollable={true}
            >
                <Modal.Header style={{}}>
                    <div
                        style={{
                            display: "flex",
                            height: "30px",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div
                                    onClick={() => {
                                        setShowModal(false);
                                        setSelectPowerBI([]);
                                        setAccessUser([]);
                                        setOptions([]);
                                        setSelectBussines([]);
                                    }}
                                    style={{
                                        cursor: "pointer",
                                        width: "20px",
                                        textAlign: "center",
                                        marginRight: "20px",
                                    }}
                                >
                                    <img src={close} alt="icone de fechar" />
                                </div>
                                <p className="textHeaderModalUser">
                                    {data.title ? "Editar acesso BI" : "Novo acesso BI"}
                                </p>
                            </div>
                            <button style={buttonStyle} onClick={handleEditOrAdd}>
                                {data.title ? "Editar" : "Novo"}
                            </button>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                    }}
                >
                    <div style={{ marginTop: "-5px" }}>
                        {data.business &&
                            <div style={{ marginTop: "12px", marginBottom: "22px" }}>
                                <p style={{ marginBottom: "8px" }}>Empresa dona do power BI</p>
                                <div style={{ border: "1px solid #d7d7d7", borderRadius: "12px", paddingLeft: "10px", height: "45px", paddingTop: "12px", backgroundColor: "#e8e8e8" }}>
                                    <p>{data.business}</p>
                                </div>
                            </div>
                        }
                        <div
                            onClick={() => { setImage(""); }}
                            style={{ position: "relative", cursor: "pointer" }}
                        >
                            <div style={{ position: "absolute", right: "-5px", top: "20px" }}>
                                <svg
                                    width="28px"
                                    height="28px"
                                    viewBox="0 0 24.00 24.00"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0">
                                        <rect
                                            x="0"
                                            y="0"
                                            width="24.00"
                                            height="24.00"
                                            rx="12"
                                            fill="#ffffff"
                                            strokeWidth="0"
                                        ></rect>
                                    </g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        {" "}
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="#000000"
                                            strokeWidth="2.4"
                                        ></circle>{" "}
                                        <path
                                            d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
                                            stroke="#000000"
                                            strokeWidth="2.4"
                                            strokeLinejoin="round"
                                        ></path>{" "}
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <p style={{ marginBottom: "8px" }}>Imagem do BI</p>
                        {image ? (
                            <img src={image} alt={"imagem do dashboard"} style={styleImage} />
                        ) : (
                            <div
                                style={imageError ? styleImageError : styleImage}
                                onClick={handleClick}
                            >
                                <input
                                    type="file"
                                    onChange={(text) => {
                                        loadImage(text.target.files[0]);
                                    }}
                                    ref={hiddenFileInput}
                                    style={{ display: "none" }}
                                    accept="image/png, image/jpeg"
                                />
                                <svg
                                    width="156"
                                    height="78"
                                    viewBox="0 0 156 78"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M68.3369 9.368C69.2305 8.77087 70.2811 8.45215 71.3558 8.45215C72.0458 8.45215 72.6052 9.01155 72.6052 9.70161C72.6052 10.3917 72.0458 10.9511 71.3558 10.9511C70.7753 10.9511 70.2078 11.1232 69.7251 11.4458C69.2424 11.7683 68.8662 12.2268 68.6441 12.7631C68.4219 13.2995 68.3638 13.8897 68.477 14.4591C68.5903 15.0286 68.8698 15.5516 69.2803 15.9621C69.6908 16.3726 70.2138 16.6522 70.7832 16.7655C71.3526 16.8787 71.9428 16.8206 72.4791 16.5984C73.0154 16.3763 73.4738 16 73.7964 15.5173C74.1189 15.0346 74.291 14.467 74.291 13.8865C74.291 13.1964 74.8504 12.637 75.5404 12.637C76.2304 12.637 76.7898 13.1964 76.7898 13.8865C76.7898 14.9613 76.4711 16.012 75.874 16.9056C75.2769 17.7993 74.4282 18.4958 73.4353 18.9071C72.4424 19.3184 71.3498 19.4261 70.2957 19.2164C69.2416 19.0067 68.2734 18.4891 67.5134 17.7291C66.7535 16.9691 66.236 16.0008 66.0263 14.9467C65.8166 13.8925 65.9242 12.7998 66.3355 11.8068C66.7468 10.8139 67.4433 9.96513 68.3369 9.368Z"
                                        fill="black"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M98.5044 15.6987C99.1845 15.6987 99.7358 16.2616 99.7358 16.9558V27.482C99.7358 32.8669 98.6943 36.9633 96.0454 39.6827C93.3948 42.4038 89.4001 43.4742 84.1513 43.4742H71.8488C66.6015 43.4742 62.6069 42.4042 59.9559 39.6834C57.3065 36.9643 56.2642 32.8679 56.2642 27.482V23.2498C56.2642 22.5555 56.8155 21.9927 57.4956 21.9927C58.1756 21.9927 58.727 22.5555 58.727 23.2498V27.482C58.727 32.6224 59.7369 35.8935 61.702 37.9103C63.6655 39.9255 66.8475 40.9599 71.8488 40.9599H84.1513C89.1542 40.9599 92.3361 39.9251 94.2991 37.9098C96.2638 35.8928 97.273 32.6217 97.273 27.482V16.9558C97.273 16.2616 97.8244 15.6987 98.5044 15.6987Z"
                                        fill="black"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M60.0072 3.71379C62.6934 1.0485 66.7412 0 72.0621 0H80.3808C81.0667 0 81.6227 0.551654 81.6227 1.23215C81.6227 1.91265 81.0667 2.46431 80.3808 2.46431H72.0621C66.9863 2.46431 63.756 3.47925 61.7634 5.45631C59.7708 7.43338 58.7479 10.6384 58.7479 15.6746C58.7479 16.3551 58.1919 16.9068 57.506 16.9068C56.8202 16.9068 56.2642 16.3551 56.2642 15.6746C56.2642 10.3953 57.3209 6.37907 60.0072 3.71379Z"
                                        fill="black"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M84.0391 7.24669C84.0391 6.57974 84.6178 6.03906 85.3316 6.03906H97.237C97.9509 6.03906 98.5296 6.57974 98.5296 7.24669C98.5296 7.91364 97.9509 8.45432 97.237 8.45432H85.3316C84.6178 8.45432 84.0391 7.91364 84.0391 7.24669Z"
                                        fill="black"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M91.2808 0C91.9477 0 92.4883 0.578741 92.4883 1.29266V13.1989C92.4883 13.9128 91.9477 14.4915 91.2808 14.4915C90.6139 14.4915 90.0732 13.9128 90.0732 13.1989V1.29266C90.0732 0.578741 90.6139 0 91.2808 0Z"
                                        fill="black"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M90.1344 23.7601L81.5882 31.1586L81.5655 31.1778C80.5265 32.0345 79.2228 32.5028 77.8774 32.5028C76.532 32.5028 75.2283 32.0345 74.1893 31.1778C74.1781 31.1686 74.1671 31.1591 74.1562 31.1495L73.4965 30.5654C72.944 30.1196 72.2655 29.8591 71.5568 29.8212C70.8438 29.7831 70.1371 29.9723 69.5381 30.3615L59.3994 37.2242C58.8335 37.6072 58.0649 37.458 57.6826 36.8908C57.3004 36.3236 57.4493 35.5533 58.0153 35.1703L68.1794 28.2904C69.2195 27.6106 70.4485 27.28 71.6885 27.3463C72.9285 27.4126 74.1154 27.8724 75.0775 28.6593C75.0899 28.6695 75.1022 28.68 75.1143 28.6907L75.776 29.2765C76.3698 29.7602 77.1118 30.0244 77.8774 30.0244C78.6451 30.0244 79.3891 29.7587 79.9837 29.2725L88.5299 21.874L88.5526 21.8548C89.5916 20.9982 90.8953 20.5298 92.2407 20.5298C93.5862 20.5298 94.8898 20.9982 95.9288 21.8548L95.9516 21.8741L99.3066 24.7788C99.8234 25.2262 99.8804 26.0088 99.434 26.5267C98.9876 27.0446 98.2067 27.1018 97.6899 26.6544L94.347 23.7601C93.7524 23.2739 93.0084 23.0083 92.2407 23.0083C91.473 23.0083 90.729 23.2739 90.1344 23.7601Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M5.48519 63.7156V69.8896C5.48519 70.7576 5.69519 71.4016 6.11519 71.8216C6.54453 72.2416 7.13719 72.4516 7.89319 72.4516C8.63986 72.4516 9.22319 72.2416 9.64319 71.8216C10.0725 71.4016 10.2872 70.7576 10.2872 69.8896V63.7156H11.5612V69.8756C11.5612 70.6876 11.3979 71.3736 11.0712 71.9336C10.7445 72.4843 10.3012 72.895 9.74119 73.1656C9.19053 73.4363 8.56986 73.5716 7.87919 73.5716C7.18853 73.5716 6.56319 73.4363 6.00319 73.1656C5.45253 72.895 5.01386 72.4843 4.68719 71.9336C4.36986 71.3736 4.21119 70.6876 4.21119 69.8756V63.7156H5.48519ZM15.1628 67.2156C15.4148 66.777 15.7882 66.413 16.2828 66.1236C16.7868 65.825 17.3702 65.6756 18.0328 65.6756C18.7142 65.6756 19.3302 65.839 19.8808 66.1656C20.4408 66.4923 20.8795 66.9543 21.1968 67.5516C21.5142 68.1396 21.6728 68.8256 21.6728 69.6096C21.6728 70.3843 21.5142 71.075 21.1968 71.6816C20.8795 72.2883 20.4408 72.7596 19.8808 73.0956C19.3302 73.4316 18.7142 73.5996 18.0328 73.5996C17.3795 73.5996 16.8008 73.455 16.2968 73.1656C15.8022 72.867 15.4242 72.4983 15.1628 72.0596V77.1136H13.8888V65.8016H15.1628V67.2156ZM20.3708 69.6096C20.3708 69.031 20.2542 68.527 20.0208 68.0976C19.7875 67.6683 19.4702 67.3416 19.0688 67.1176C18.6768 66.8936 18.2428 66.7816 17.7668 66.7816C17.3002 66.7816 16.8662 66.8983 16.4648 67.1316C16.0728 67.3556 15.7555 67.687 15.5128 68.1256C15.2795 68.555 15.1628 69.0543 15.1628 69.6236C15.1628 70.2023 15.2795 70.711 15.5128 71.1496C15.7555 71.579 16.0728 71.9103 16.4648 72.1436C16.8662 72.3676 17.3002 72.4796 17.7668 72.4796C18.2428 72.4796 18.6768 72.3676 19.0688 72.1436C19.4702 71.9103 19.7875 71.579 20.0208 71.1496C20.2542 70.711 20.3708 70.1976 20.3708 69.6096ZM24.8262 63.1136V73.4736H23.5522V63.1136H24.8262ZM30.5459 73.5996C29.8272 73.5996 29.1739 73.4363 28.5859 73.1096C28.0072 72.783 27.5499 72.321 27.2139 71.7236C26.8872 71.117 26.7239 70.417 26.7239 69.6236C26.7239 68.8396 26.8919 68.149 27.2279 67.5516C27.5732 66.945 28.0399 66.483 28.6279 66.1656C29.2159 65.839 29.8739 65.6756 30.6019 65.6756C31.3299 65.6756 31.9879 65.839 32.5759 66.1656C33.1639 66.483 33.6259 66.9403 33.9619 67.5376C34.3072 68.135 34.4799 68.8303 34.4799 69.6236C34.4799 70.417 34.3025 71.117 33.9479 71.7236C33.6025 72.321 33.1312 72.783 32.5339 73.1096C31.9365 73.4363 31.2739 73.5996 30.5459 73.5996ZM30.5459 72.4796C31.0032 72.4796 31.4325 72.3723 31.8339 72.1576C32.2352 71.943 32.5572 71.621 32.7999 71.1916C33.0519 70.7623 33.1779 70.2396 33.1779 69.6236C33.1779 69.0076 33.0565 68.485 32.8139 68.0556C32.5712 67.6263 32.2539 67.309 31.8619 67.1036C31.4699 66.889 31.0452 66.7816 30.5879 66.7816C30.1212 66.7816 29.6919 66.889 29.2999 67.1036C28.9172 67.309 28.6092 67.6263 28.3759 68.0556C28.1425 68.485 28.0259 69.0076 28.0259 69.6236C28.0259 70.249 28.1379 70.7763 28.3619 71.2056C28.5952 71.635 28.9032 71.957 29.2859 72.1716C29.6685 72.377 30.0885 72.4796 30.5459 72.4796ZM35.8813 69.6096C35.8813 68.8256 36.04 68.1396 36.3573 67.5516C36.6747 66.9543 37.1087 66.4923 37.6593 66.1656C38.2193 65.839 38.84 65.6756 39.5213 65.6756C40.1933 65.6756 40.7767 65.8203 41.2713 66.1096C41.766 66.399 42.1347 66.763 42.3773 67.2016V65.8016H43.6653V73.4736H42.3773V72.0456C42.1253 72.4936 41.7473 72.867 41.2433 73.1656C40.7487 73.455 40.17 73.5996 39.5073 73.5996C38.826 73.5996 38.21 73.4316 37.6593 73.0956C37.1087 72.7596 36.6747 72.2883 36.3573 71.6816C36.04 71.075 35.8813 70.3843 35.8813 69.6096ZM42.3773 69.6236C42.3773 69.045 42.2607 68.541 42.0273 68.1116C41.794 67.6823 41.4767 67.3556 41.0753 67.1316C40.6833 66.8983 40.2493 66.7816 39.7733 66.7816C39.2973 66.7816 38.8633 66.8936 38.4713 67.1176C38.0793 67.3416 37.7667 67.6683 37.5333 68.0976C37.3 68.527 37.1833 69.031 37.1833 69.6096C37.1833 70.1976 37.3 70.711 37.5333 71.1496C37.7667 71.579 38.0793 71.9103 38.4713 72.1436C38.8633 72.3676 39.2973 72.4796 39.7733 72.4796C40.2493 72.4796 40.6833 72.3676 41.0753 72.1436C41.4767 71.9103 41.794 71.579 42.0273 71.1496C42.2607 70.711 42.3773 70.2023 42.3773 69.6236ZM45.5446 69.6096C45.5446 68.8256 45.7033 68.1396 46.0206 67.5516C46.338 66.9543 46.772 66.4923 47.3226 66.1656C47.8826 65.839 48.508 65.6756 49.1987 65.6756C49.796 65.6756 50.3513 65.8156 50.8646 66.0956C51.378 66.3663 51.77 66.7256 52.0407 67.1736V63.1136H53.3287V73.4736H52.0407V72.0316C51.7887 72.489 51.4153 72.867 50.9207 73.1656C50.426 73.455 49.8473 73.5996 49.1846 73.5996C48.5033 73.5996 47.8826 73.4316 47.3226 73.0956C46.772 72.7596 46.338 72.2883 46.0206 71.6816C45.7033 71.075 45.5446 70.3843 45.5446 69.6096ZM52.0407 69.6236C52.0407 69.045 51.924 68.541 51.6907 68.1116C51.4573 67.6823 51.14 67.3556 50.7387 67.1316C50.3467 66.8983 49.9126 66.7816 49.4366 66.7816C48.9606 66.7816 48.5267 66.8936 48.1347 67.1176C47.7426 67.3416 47.43 67.6683 47.1967 68.0976C46.9633 68.527 46.8466 69.031 46.8466 69.6096C46.8466 70.1976 46.9633 70.711 47.1967 71.1496C47.43 71.579 47.7426 71.9103 48.1347 72.1436C48.5267 72.3676 48.9606 72.4796 49.4366 72.4796C49.9126 72.4796 50.3467 72.3676 50.7387 72.1436C51.14 71.9103 51.4573 71.579 51.6907 71.1496C51.924 70.711 52.0407 70.2023 52.0407 69.6236ZM60.2768 64.5556C60.0341 64.5556 59.8288 64.4716 59.6608 64.3036C59.4928 64.1356 59.4088 63.9303 59.4088 63.6876C59.4088 63.445 59.4928 63.2396 59.6608 63.0716C59.8288 62.9036 60.0341 62.8196 60.2768 62.8196C60.5101 62.8196 60.7061 62.9036 60.8648 63.0716C61.0328 63.2396 61.1168 63.445 61.1168 63.6876C61.1168 63.9303 61.0328 64.1356 60.8648 64.3036C60.7061 64.4716 60.5101 64.5556 60.2768 64.5556ZM60.8928 65.8016V73.4736H59.6188V65.8016H60.8928ZM72.4925 65.6616C73.0898 65.6616 73.6218 65.7876 74.0885 66.0396C74.5551 66.2823 74.9238 66.651 75.1945 67.1456C75.4651 67.6403 75.6005 68.2423 75.6005 68.9516V73.4736H74.3405V69.1336C74.3405 68.3683 74.1491 67.785 73.7665 67.3836C73.3931 66.973 72.8845 66.7676 72.2405 66.7676C71.5778 66.7676 71.0505 66.9823 70.6585 67.4116C70.2665 67.8316 70.0705 68.443 70.0705 69.2456V73.4736H68.8105V69.1336C68.8105 68.3683 68.6191 67.785 68.2365 67.3836C67.8631 66.973 67.3545 66.7676 66.7105 66.7676C66.0478 66.7676 65.5205 66.9823 65.1285 67.4116C64.7365 67.8316 64.5405 68.443 64.5405 69.2456V73.4736H63.2665V65.8016H64.5405V66.9076C64.7925 66.5063 65.1285 66.1983 65.5485 65.9836C65.9778 65.769 66.4491 65.6616 66.9625 65.6616C67.6065 65.6616 68.1758 65.8063 68.6705 66.0956C69.1651 66.385 69.5338 66.8096 69.7765 67.3696C69.9911 66.8283 70.3458 66.4083 70.8405 66.1096C71.3351 65.811 71.8858 65.6616 72.4925 65.6616ZM77.4167 69.6096C77.4167 68.8256 77.5754 68.1396 77.8927 67.5516C78.21 66.9543 78.644 66.4923 79.1947 66.1656C79.7547 65.839 80.3754 65.6756 81.0567 65.6756C81.7287 65.6756 82.312 65.8203 82.8067 66.1096C83.3014 66.399 83.67 66.763 83.9127 67.2016V65.8016H85.2007V73.4736H83.9127V72.0456C83.6607 72.4936 83.2827 72.867 82.7787 73.1656C82.284 73.455 81.7054 73.5996 81.0427 73.5996C80.3614 73.5996 79.7454 73.4316 79.1947 73.0956C78.644 72.7596 78.21 72.2883 77.8927 71.6816C77.5754 71.075 77.4167 70.3843 77.4167 69.6096ZM83.9127 69.6236C83.9127 69.045 83.796 68.541 83.5627 68.1116C83.3294 67.6823 83.012 67.3556 82.6107 67.1316C82.2187 66.8983 81.7847 66.7816 81.3087 66.7816C80.8327 66.7816 80.3987 66.8936 80.0067 67.1176C79.6147 67.3416 79.302 67.6683 79.0687 68.0976C78.8354 68.527 78.7187 69.031 78.7187 69.6096C78.7187 70.1976 78.8354 70.711 79.0687 71.1496C79.302 71.579 79.6147 71.9103 80.0067 72.1436C80.3987 72.3676 80.8327 72.4796 81.3087 72.4796C81.7847 72.4796 82.2187 72.3676 82.6107 72.1436C83.012 71.9103 83.3294 71.579 83.5627 71.1496C83.796 70.711 83.9127 70.2023 83.9127 69.6236ZM90.72 65.6756C91.3827 65.6756 91.9613 65.8203 92.456 66.1096C92.96 66.399 93.3333 66.763 93.576 67.2016V65.8016H94.864V73.6416C94.864 74.3416 94.7147 74.9623 94.416 75.5036C94.1173 76.0543 93.688 76.4836 93.128 76.7916C92.5773 77.0996 91.9333 77.2536 91.196 77.2536C90.188 77.2536 89.348 77.0156 88.676 76.5396C88.004 76.0636 87.6073 75.415 87.486 74.5936H88.746C88.886 75.0603 89.1753 75.4336 89.614 75.7136C90.0527 76.003 90.58 76.1476 91.196 76.1476C91.896 76.1476 92.4653 75.9283 92.904 75.4896C93.352 75.051 93.576 74.435 93.576 73.6416V72.0316C93.324 72.4796 92.9507 72.853 92.456 73.1516C91.9613 73.4503 91.3827 73.5996 90.72 73.5996C90.0387 73.5996 89.418 73.4316 88.858 73.0956C88.3073 72.7596 87.8733 72.2883 87.556 71.6816C87.2387 71.075 87.08 70.3843 87.08 69.6096C87.08 68.8256 87.2387 68.1396 87.556 67.5516C87.8733 66.9543 88.3073 66.4923 88.858 66.1656C89.418 65.839 90.0387 65.6756 90.72 65.6756ZM93.576 69.6236C93.576 69.045 93.4593 68.541 93.226 68.1116C92.9927 67.6823 92.6753 67.3556 92.274 67.1316C91.882 66.8983 91.448 66.7816 90.972 66.7816C90.496 66.7816 90.062 66.8936 89.67 67.1176C89.278 67.3416 88.9653 67.6683 88.732 68.0976C88.4987 68.527 88.382 69.031 88.382 69.6096C88.382 70.1976 88.4987 70.711 88.732 71.1496C88.9653 71.579 89.278 71.9103 89.67 72.1436C90.062 72.3676 90.496 72.4796 90.972 72.4796C91.448 72.4796 91.882 72.3676 92.274 72.1436C92.6753 71.9103 92.9927 71.579 93.226 71.1496C93.4593 70.711 93.576 70.2023 93.576 69.6236ZM104.219 69.3436C104.219 69.5863 104.205 69.843 104.177 70.1136H98.0453C98.092 70.8696 98.3487 71.4623 98.8153 71.8916C99.2913 72.3116 99.8653 72.5216 100.537 72.5216C101.088 72.5216 101.545 72.3956 101.909 72.1436C102.283 71.8823 102.544 71.537 102.693 71.1076H104.065C103.86 71.845 103.449 72.447 102.833 72.9136C102.217 73.371 101.452 73.5996 100.537 73.5996C99.8093 73.5996 99.156 73.4363 98.5773 73.1096C98.008 72.783 97.56 72.321 97.2333 71.7236C96.9067 71.117 96.7433 70.417 96.7433 69.6236C96.7433 68.8303 96.902 68.135 97.2193 67.5376C97.5367 66.9403 97.98 66.483 98.5493 66.1656C99.128 65.839 99.7907 65.6756 100.537 65.6756C101.265 65.6756 101.909 65.8343 102.469 66.1516C103.029 66.469 103.459 66.9076 103.757 67.4676C104.065 68.0183 104.219 68.6436 104.219 69.3436ZM102.903 69.0776C102.903 68.5923 102.796 68.177 102.581 67.8316C102.367 67.477 102.073 67.211 101.699 67.0336C101.335 66.847 100.929 66.7536 100.481 66.7536C99.8373 66.7536 99.2867 66.959 98.8293 67.3696C98.3813 67.7803 98.1247 68.3496 98.0593 69.0776H102.903ZM115.329 65.6616C115.927 65.6616 116.459 65.7876 116.925 66.0396C117.392 66.2823 117.761 66.651 118.031 67.1456C118.302 67.6403 118.437 68.2423 118.437 68.9516V73.4736H117.177V69.1336C117.177 68.3683 116.986 67.785 116.603 67.3836C116.23 66.973 115.721 66.7676 115.077 66.7676C114.415 66.7676 113.887 66.9823 113.495 67.4116C113.103 67.8316 112.907 68.443 112.907 69.2456V73.4736H111.647V69.1336C111.647 68.3683 111.456 67.785 111.073 67.3836C110.7 66.973 110.191 66.7676 109.547 66.7676C108.885 66.7676 108.357 66.9823 107.965 67.4116C107.573 67.8316 107.377 68.443 107.377 69.2456V73.4736H106.103V65.8016H107.377V66.9076C107.629 66.5063 107.965 66.1983 108.385 65.9836C108.815 65.769 109.286 65.6616 109.799 65.6616C110.443 65.6616 111.013 65.8063 111.507 66.0956C112.002 66.385 112.371 66.8096 112.613 67.3696C112.828 66.8283 113.183 66.4083 113.677 66.1096C114.172 65.811 114.723 65.6616 115.329 65.6616ZM131.188 66.5716C131.188 67.3836 130.908 68.0603 130.348 68.6016C129.798 69.1336 128.953 69.3996 127.814 69.3996H125.938V73.4736H124.664V63.7156H127.814C128.916 63.7156 129.751 63.9816 130.32 64.5136C130.899 65.0456 131.188 65.7316 131.188 66.5716ZM127.814 68.3496C128.524 68.3496 129.046 68.1956 129.382 67.8876C129.718 67.5796 129.886 67.141 129.886 66.5716C129.886 65.3676 129.196 64.7656 127.814 64.7656H125.938V68.3496H127.814ZM140.646 73.4736H139.372L134.248 65.7036V73.4736H132.974V63.7016H134.248L139.372 71.4576V63.7016H140.646V73.4736ZM150.412 66.5436C150.142 65.9743 149.75 65.5356 149.236 65.2276C148.723 64.9103 148.126 64.7516 147.444 64.7516C146.763 64.7516 146.147 64.9103 145.596 65.2276C145.055 65.5356 144.626 65.9836 144.308 66.5716C144 67.1503 143.846 67.8223 143.846 68.5876C143.846 69.353 144 70.025 144.308 70.6036C144.626 71.1823 145.055 71.6303 145.596 71.9476C146.147 72.2556 146.763 72.4096 147.444 72.4096C148.396 72.4096 149.18 72.125 149.796 71.5556C150.412 70.9863 150.772 70.2163 150.874 69.2456H146.982V68.2096H152.232V69.1896C152.158 69.9923 151.906 70.7296 151.476 71.4016C151.047 72.0643 150.482 72.5916 149.782 72.9836C149.082 73.3663 148.303 73.5576 147.444 73.5576C146.539 73.5576 145.713 73.3476 144.966 72.9276C144.22 72.4983 143.627 71.9056 143.188 71.1496C142.759 70.3936 142.544 69.5396 142.544 68.5876C142.544 67.6356 142.759 66.7816 143.188 66.0256C143.627 65.2603 144.22 64.6676 144.966 64.2476C145.713 63.8183 146.539 63.6036 147.444 63.6036C148.48 63.6036 149.395 63.8603 150.188 64.3736C150.991 64.887 151.574 65.6103 151.938 66.5436H150.412Z"
                                        fill="#111729"
                                    />
                                </svg>
                            </div>
                        )}
                    </div>

                    <div style={{ marginTop: "20px" }}>
                        <p style={{ marginBottom: "8px" }}>Nome do power BI</p>
                        <input
                            style={titleError ? inputStyleError : inputStyle}
                            value={title}
                            onChange={(text) => {
                                setTitle(text.target.value);
                            }}
                            placeholder="Insira uma nome"
                        />
                    </div>

                    <div style={{ marginTop: "20px" }}>
                        <p style={{ marginBottom: "8px" }}>Link do power BI</p>
                        <input
                            style={linkError ? inputStyleError : inputStyle}
                            value={link}
                            onChange={(text) => {
                                setLink(text.target.value);
                            }}
                            placeholder="Insira o link"
                        />
                    </div>

                    {!data?.id &&
                        <div style={{ marginTop: "20px" }}>
                            <p style={{ marginBottom: "8px" }}>Qual é a empresa</p>
                            <Select
                                color="#000"
                                placeholder="Selecione uma empresa"
                                dropdownHeight={"100px"}
                                keepSelectedInList={true}
                                options={business}
                                searchBy="business"
                                labelField="business"
                                valueField="business"
                                onChange={(value) => { setSelectBussines(value); }}
                                style={selectBusinessError ? styleSelectError : styleSelect}
                                values={selectBusiness}
                            />
                        </div>
                    }

                    <div style={{ marginTop: "20px" }}>
                        <p style={{ marginBottom: "8px" }}>Quem tem acesso ao Power BI</p>
                        <Select
                            color="#000"
                            placeholder="Selecione os acessos"
                            dropdownHeight={"100px"}
                            keepSelectedInList={true}
                            options={data.id ? options : createOption}
                            multi={true}
                            searchBy="name"
                            labelField="name"
                            valueField="id"
                            onChange={(value) => { setAccessUser(value); }}
                            style={accessUserError ? styleSelectError : styleSelect}
                            values={accessUser}
                        />
                    </div>

                    <div style={{ marginTop: "20px" }}>
                        <>
                            {!allAccess ? (
                                <div
                                    onClick={() => setAllAccess((prevState) => !prevState)}
                                    style={{ cursor: "pointer", display: "flex" }}
                                >
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x=".5"
                                            y=".5"
                                            width="19"
                                            height="19"
                                            rx="4.5"
                                            fill="#fff"
                                            stroke="#000"
                                        />
                                        <path
                                            d="M8.745 13.136a.908.908 0 0 1-.644-.266l-1.944-1.944a.536.536 0 0 1 .758-.758l1.83 1.83 4.84-4.841a.536.536 0 0 1 .758.758L9.388 12.87a.908.908 0 0 1-.643.266Z"
                                            fill="#fff"
                                        />
                                    </svg>
                                    <p style={{ marginLeft: "10px", alignItems: "center" }}>
                                        Liberar acesso a todos usuários
                                    </p>
                                </div>
                            ) : (
                                <div
                                    onClick={() => setAllAccess((prevState) => !prevState)}
                                    style={{ cursor: "pointer", display: "flex" }}
                                >
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x=".5"
                                            y=".5"
                                            width="19"
                                            height="19"
                                            rx="4.5"
                                            fill="#000"
                                            stroke="#000"
                                        />
                                        <path
                                            d="M8.745 13.136a.908.908 0 0 1-.644-.266l-1.944-1.944a.536.536 0 0 1 .758-.758l1.83 1.83 4.84-4.841a.536.536 0 0 1 .758.758L9.388 12.87a.908.908 0 0 1-.643.266Z"
                                            fill="#fff"
                                        />
                                    </svg>
                                    <p style={{ marginLeft: "10px", alignItems: "center" }}>
                                        Liberar acesso a todos usuários
                                    </p>
                                </div>
                            )}
                        </>
                    </div>

                    <div style={{ marginBottom: "100px" }} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ModalPowerBi;